import HeaderWebsite from "../../components/HeaderWebsite";
import { EditUser } from "../../components/EditUser";

export default function EditUserPage(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
  } = props;

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <EditUser statusMode={statusMode} />
    </>
  );
}
